import React, { useEffect } from 'react'
import { Typography } from '@mui/material'
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { useSearchParams } from 'react-router'
import { usePageTitle } from '../../hooks'

import { ActiveIntegrations, AvailableIntegrations, ContactUsInfo } from '../../components'
import { PageSection, PageWrapper } from '../'
import { useModal } from '../../providers'

export const Landing = () => {
	const [ hasShownOAuthErrorModal, setHasShownOAuthErrorModal ] = React.useState( false )
	usePageTitle( 'Overview' )
	const { showModal } = useModal()

	//handle query params
	const params = useSearchParams()
	useEffect( () => {
		const [ searchParams ] = params
		const oAuthSuccess = searchParams.get( 'oauth_success' )
		if ( oAuthSuccess === 'false' && !hasShownOAuthErrorModal ) {
			//show modal saying oauth failed
			showModal( {
				title: 'Authentication Failed',
				headerText: 'Authentication Failed',
				content: 'There was an error during OAuth authentication. Please try again or contact support if the problem persists.',
				icon: <ErrorIcon color="error" />,
				buttons: [ { label: 'Dismiss', variant: 'contained', color: 'primary' } ],
			} )
			setHasShownOAuthErrorModal( true )
		}
	}, [ params, hasShownOAuthErrorModal, showModal ] )

	return (
		<PageWrapper>
			<PageSection>
				<Typography variant={'h2'} gutterBottom>
					OEM Integrations
				</Typography>
				<Typography>
					T3 integrates with third-party platforms to sync telematics data, including AEMP data, into your T3 Fleet account. This centralizes critical fleet data including location, fuel level, odometer, operating hours, idle hours, and engine status. Consolidating this data streamlines operations and ensures compliance.
				</Typography>
			</PageSection>
			<ActiveIntegrations />
			<AvailableIntegrations />
			<ContactUsInfo />
		</PageWrapper>
	)
}
